import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, ArrowRight, Mail } from "lucide-react";
import { useI18n } from "@/i18n";

export default function ProposalConfirmed() {
  const { lang, localizePath } = useI18n();
  const EN = lang === "en";
  return (
    <div data-testid="proposal-confirmed-page" className="bg-white min-h-screen">
      <section className="pt-32 pb-16">
        <div className="max-w-2xl mx-auto px-5 lg:px-10 text-center">
          <div className="h-16 w-16 rounded-full bg-gold/20 flex items-center justify-center mx-auto">
            <CheckCircle2 className="h-8 w-8 text-gold" />
          </div>

          <p className="label-eyebrow mt-8">{EN ? "Interest confirmed" : "Conferma ricevuta"}</p>
          <h1 className="mt-4 font-serif text-4xl sm:text-5xl text-navy tracking-tight leading-[1.05]">
            {EN ? (
              <>Thank you,<br /><em className="italic text-gold font-medium">we have your interest.</em></>
            ) : (
              <>Richiesta di<br /><em className="italic text-gold font-medium">conferma ricevuta.</em></>
            )}
          </h1>

          <p className="mt-8 text-base lg:text-lg text-ink leading-relaxed">
            {EN
              ? "Thank you. We have recorded your interest in this proposal."
              : "Grazie, abbiamo ricevuto il tuo interesse per questa proposta."}
          </p>
          <p className="mt-4 text-base text-ink leading-relaxed">
            {EN
              ? "Our concierge team will now verify final availability with the charter company and put you in touch with a dedicated contact to finalise the booking."
              : "Il team Seamatch verificherà la disponibilità finale con la società charter e ti metterà in contatto con il referente per completare la prenotazione."}
          </p>

          <div className="mt-10 p-6 rounded-2xl bg-sand border border-gold/40 text-left">
            <p className="text-[11px] uppercase tracking-wider text-gold font-semibold">{EN ? "Important" : "Importante"}</p>
            <p className="mt-2 font-serif text-lg text-navy">
              {EN
                ? "No payment is processed through Seamatch at this stage."
                : "In questa fase non è richiesto alcun pagamento tramite Seamatch."}
            </p>
            <p className="mt-2 text-sm text-ink leading-relaxed">
              {EN
                ? "All bookings are finalised offline directly with the charter company. Your Seamatch concierge will guide you step by step, up to contract signature."
                : "Tutte le prenotazioni vengono completate offline direttamente con la società charter. Il referente Seamatch ti accompagnerà passo passo fino alla firma del contratto."}
            </p>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link to={localizePath("/")}>
              <Button data-testid="back-home" className="bg-navy text-white hover:bg-[#06101f] rounded-full h-12 px-7">
                {EN ? "Back to Seamatch" : "Torna al sito Seamatch"}
                <ArrowRight className="h-4 w-4 ml-2" />
              </Button>
            </Link>
            <a href="mailto:info@seamatch.pro">
              <Button variant="outline" className="border-navy/20 text-navy hover:bg-sand rounded-full h-12 px-7">
                <Mail className="h-4 w-4 mr-2" /> {EN ? "Write to us" : "Scrivici"}
              </Button>
            </a>
          </div>

          <p className="mt-8 text-xs text-ink/50">
            {EN
              ? <>A confirmation email is on its way. For any urgent question write to <a href="mailto:info@seamatch.pro" className="text-navy underline">info@seamatch.pro</a>.</>
              : <>Riceverai una conferma via email a breve. Per qualsiasi domanda urgente, scrivi a <a href="mailto:info@seamatch.pro" className="text-navy underline">info@seamatch.pro</a>.</>}
          </p>
        </div>
      </section>
    </div>
  );
}
